export enum HeartRateStatus {
    Normal = 1,
    Abnormal = 2
}
